const PdpDeliveryAvailability = {
  parts: [
    'root',
    'card',
    'titleRow',
    'title',
    'titleTooltipButton',
    'locationSection',
    'locationLabel',
    'locationAddressRow',
    'locationSearchIconWrap',
    'locationSummary',
    'changeLink',
    'searchRow',
    'locationInput',
    'locationInputsGroup',
    'locationAutocompleteRow',
    'locationAutocompleteIconWrap',
    'locationAutocompleteInput',
    'locationAutocompleteClear',
    'locationUpdateButton',
    'methodsStack',
    'methodsEmpty',
    'methodsEmptyNotice',
    'methodsEmptyIcon',
    'methodsEmptyText',
    'methodRow',
    'methodIcon',
    'methodIconButton',
    'methodBody',
    'methodBodySecondary',
    'methodName',
    'methodLead',
    'methodDescription',
    'methodDescriptionStrong',
    'methodPrice',
    'disclaimer',
    'divider',
  ],
  baseStyle: {
    root: {
      fontFamily: 'body',
      paddingTop: {base: 14, lg: 16},
      paddingBottom: 0,
      width: '100%',
      borderTop: '2px solid',
      borderColor: 'grayAlpha.10',
      sx: {
        overflowAnchor: 'none',
        '&:not(:has(+ .want-it-sooner-promo))': {
          marginBottom: '16px',
        },
        '& .text-greyscale-70': {
          color: 'greyscale.70',
        },
        '&.opacity-50': {
          position: 'relative',
          '&::before': {
            content: '""',
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'primary.paleLinen',
            opacity: 0.5,
            zIndex: 1,
          },
        },
        '& .text-greyscale-65': {
          color: 'greyscale.65',
        },
      },
    },
    card: {
      bg: 'white',
      borderColor: 'grayAlpha.10',
      borderRadius: 'base',
      borderStyle: 'solid',
      borderWidth: '1.5px',
      padding: 0,
    },
    titleRow: {
      alignItems: 'flex-start',
      columnGap: 2,
      flexWrap: 'wrap',
      justifyContent: 'flex-start',
      marginBottom: {base: 3, md: 4},
      rowGap: 2,
    },
    title: {
      color: 'greyscale.90',
      fontFamily: 'body',
      fontSize: 'lg',
      fontStyle: 'normal',
      fontWeight: 500,
      letterSpacing: 'normal',
      lineHeight: 'shorter',
      sx: {
        fontVariantNumeric: 'lining-nums proportional-nums',
      },
    },
    titleTooltipButton: {
      alignItems: 'center',
      background: 'none',
      border: 'none',
      borderRadius: 'base',
      cursor: 'pointer',
      display: 'inline-flex',
      flexShrink: 0,
      h: 5,
      justifyContent: 'center',
      lineHeight: 0,
      minH: 5,
      minW: 5,
      p: 0,
      w: 5,
      _focusVisible: {
        boxShadow: 'outline',
      },
    },
    locationSection: {
      alignItems: 'flex-start',
      alignSelf: 'stretch',
      display: 'flex',
      flexDirection: 'column',
      gap: 4,
      paddingBottom: 6,
      paddingLeft: 6,
      paddingRight: 6,
      paddingTop: 5,
      width: '100%',
    },
    locationLabel: {
      color: 'grayAlpha.90',
      fontFamily: 'body',
      fontSize: {base: 'sm', md: 'md'},
      fontStyle: 'normal',
      fontWeight: 600,
      letterSpacing: 'normal',
      lineHeight: 'base',
      marginBottom: 0,
      sx: {
        fontVariantNumeric: 'lining-nums proportional-nums',
      },
    },
    locationAddressRow: {
      alignItems: 'center',
      alignSelf: 'stretch',
      bg: 'white',
      borderColor: 'grayAlpha.10',
      borderRadius: 'lg',
      borderStyle: 'solid',
      borderWidth: '1px',
      boxSizing: 'border-box',
      display: 'flex',
      flexDirection: 'row',
      gap: 2.5,
      height: 13.5,
      justifyContent: 'flex-start',
      minH: 13.5,
      p: 4.5,
      width: '100%',
    },
    locationSearchIconWrap: {
      alignItems: 'center',
      display: 'inline-flex',
      flexShrink: 0,
      h: 5,
      justifyContent: 'center',
      lineHeight: 0,
      minH: 5,
      minW: 5,
      w: 5,
    },
    locationSummary: {
      color: 'grayAlpha.90',
      flex: 1,
      fontFamily: 'body',
      fontSize: {base: 'sm', md: 'md'},
      fontStyle: 'normal',
      fontWeight: 600,
      letterSpacing: 'normal',
      lineHeight: 'base',
      minWidth: 0,
      overflow: 'hidden',
      sx: {
        fontVariantNumeric: 'lining-nums proportional-nums',
      },
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    changeLink: {
      color: 'brandColors.primaryDarkLinen',
      cursor: 'pointer',
      flexShrink: 0,
      fontFamily: 'body',
      fontSize: {base: 'sm', md: 'md'},
      fontStyle: 'normal',
      fontWeight: 600,
      letterSpacing: 'normal',
      lineHeight: 'base',
      sx: {
        fontVariantNumeric: 'lining-nums proportional-nums',
      },
      textAlign: 'right',
      textDecoration: 'none',
      whiteSpace: 'nowrap',
    },
    searchRow: {
      alignItems: 'center',
      alignSelf: 'stretch',
      columnGap: 3,
      display: 'flex',
      flexDirection: 'row',
      flexWrap: {base: 'wrap', sm: 'nowrap'},
      minH: 13.5,
      padding: 0,
      rowGap: 3,
      width: '100%',
    },
    locationInput: {
      bg: 'white',
      borderColor: 'grayAlpha.10',
      borderRadius: 'md',
      borderStyle: 'solid',
      borderWidth: '1px',
      boxSizing: 'border-box',
      color: 'grayAlpha.90',
      fontFamily: 'body',
      fontSize: {base: 'sm', md: 'md'},
      fontWeight: 600,
      h: 13.5,
      lineHeight: 'base',
      minH: 13.5,
      minWidth: 0,
      px: 3,
      sx: {
        fontVariantNumeric: 'lining-nums proportional-nums',
      },
      _focusVisible: {
        borderColor: 'brandColors.primaryDarkLinen',
        boxShadow: '0 0 0 1px',
      },
      _placeholder: {
        color: 'gray.500',
        fontWeight: 400,
      },
    },
    locationInputsGroup: {
      alignItems: {base: 'stretch', sm: 'center'},
      display: 'flex',
      flex: 1,
      flexDirection: {base: 'column', sm: 'row'},
      gap: 2,
      minH: 13.5,
      minWidth: 0,
    },
    locationAutocompleteRow: {
      alignItems: 'center',
      alignSelf: 'stretch',
      bg: 'white',
      borderColor: 'grayAlpha.10',
      borderRadius: '4px',
      borderStyle: 'solid',
      borderWidth: '1px',
      boxSizing: 'border-box',
      display: 'flex',
      flex: 1,
      gap: '10px',
      h: '54px',
      minH: '54px',
      minW: 0,
      px: '18px',
      py: 0,
      width: '100%',
      _focusWithin: {
        borderColor: 'brandColors.primaryDarkLinen',
        boxShadow: '0 0 0 1px',
      },
    },
    locationAutocompleteIconWrap: {
      alignItems: 'center',
      display: 'flex',
      flexShrink: 0,
      h: '20px',
      justifyContent: 'center',
      lineHeight: 0,
      minH: '20px',
      minW: '20px',
      w: '20px',
    },
    locationAutocompleteInput: {
      bg: 'transparent',
      border: 'none',
      boxShadow: 'none',
      color: 'grayAlpha.90',
      flex: 1,
      fontFamily: 'body',
      fontSize: '16px',
      fontStyle: 'normal',
      fontWeight: 600,
      h: 'auto',
      letterSpacing: 'normal',
      lineHeight: '1.4',
      minH: 0,
      minW: 0,
      px: 0,
      py: 0,
      sx: {
        fontVariantNumeric: 'lining-nums proportional-nums',
      },
      _focusVisible: {
        border: 'none',
        boxShadow: 'none',
      },
      _placeholder: {
        color: 'gray.500',
        fontWeight: 400,
      },
    },
    locationAutocompleteClear: {
      alignItems: 'center',
      background: 'transparent',
      border: 'none',
      color: 'gray.600',
      cursor: 'pointer',
      display: 'flex',
      flexShrink: 0,
      h: '24px',
      justifyContent: 'center',
      lineHeight: 0,
      minH: '24px',
      minW: '24px',
      p: 0,
      w: '24px',
      _focusVisible: {
        boxShadow: 'outline',
      },
    },
    locationUpdateButton: {
      alignSelf: 'center',
      cursor: 'pointer',
      flexShrink: 0,
      marginLeft: 'auto',
      marginTop: 0,
    },
    methodsStack: {
      flexDirection: 'column',
      gap: 0,
      marginTop: 0,
    },
    methodsEmpty: {
      alignItems: 'flex-start',
      alignSelf: 'stretch',
      borderTopColor: '#E8E8E8',
      borderTopStyle: 'solid',
      borderTopWidth: '1px',
      display: 'flex',
      flexDirection: 'column',
      gap: 4,
      paddingBottom: 4,
      paddingLeft: 6,
      paddingRight: 6,
      paddingTop: 4,
      width: '100%',
    },
    methodsEmptyNotice: {
      alignItems: 'center',
      alignSelf: 'stretch',
      display: 'flex',
      flexDirection: 'row',
      gap: 4,
      width: '100%',
    },
    methodsEmptyIcon: {
      alignItems: 'center',
      display: 'inline-flex',
      flexShrink: 0,
      h: '20px',
      justifyContent: 'center',
      lineHeight: 0,
      minH: '20px',
      minW: '20px',
      p: 0,
      w: '20px',
    },
    methodsEmptyText: {
      color: 'brandColors.charcoal',
      fontStyle: 'normal',
      letterSpacing: 'normal',
      textStyle: 'labelDefault',
      sx: {
        fontVariantNumeric: 'lining-nums proportional-nums',
      },
    },
    methodRow: {
      alignItems: 'center',
      alignSelf: 'stretch',
      borderTopColor: 'gray.50',
      borderTopStyle: 'solid',
      borderTopWidth: '1px',
      boxSizing: 'border-box',
      display: 'flex',
      gap: 4,
      paddingBottom: 4,
      paddingLeft: 4,
      paddingRight: 6,
      paddingTop: 4,
      width: '100%',
    },
    methodIcon: {
      flexShrink: 0,
      lineHeight: 0,
      alignSelf: 'flex-start',
      marginTop: 0.5,
    },
    methodIconButton: {
      alignItems: 'center',
      background: 'none',
      border: 'none',
      cursor: 'default',
      display: 'inline-flex',
      flexShrink: 0,
      h: 5,
      justifyContent: 'center',
      lineHeight: 0,
      minH: 5,
      minW: 5,
      p: 0,
      w: 5,
    },
    methodBody: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      gap: 1,
      minWidth: 0,
    },
    methodBodySecondary: {
      display: 'flex',
      flexFlow: 'row wrap',
      minWidth: 0,
    },
    methodName: {
      color: 'gray.900',
      fontFamily: 'body',
      fontSize: {base: 'sm', md: 'md'},
      fontStyle: 'normal',
      fontWeight: 600,
      letterSpacing: 'normal',
      lineHeight: 'base',
      sx: {
        fontVariantNumeric: 'lining-nums proportional-nums',
      },
    },
    methodLead: {
      color: 'gray.800',
      fontFamily: 'body',
      fontSize: {base: 'sm', md: 'md'},
      fontStyle: 'normal',
      fontWeight: 600,
      letterSpacing: 'normal',
      lineHeight: 'base',
      sx: {
        fontVariantNumeric: 'lining-nums proportional-nums',
      },
    },
    methodDescription: {
      color: 'greyscale.60',
      fontFamily: 'body',
      fontSize: {base: 'sm', md: 'md'},
      fontStyle: 'normal',
      fontWeight: 400,
      letterSpacing: 'normal',
      lineHeight: 'base',
      flexBasis: {base:'100%', md:'auto'},
      sx: {
        fontVariantNumeric: 'lining-nums proportional-nums',
      },
    },
    methodDescriptionStrong: {
      color: 'gray.800',
      fontFamily: 'body',
      fontSize: {base: 'sm', md: 'md'},
      fontStyle: 'normal',
      fontWeight: 600,
      letterSpacing: 'normal',
      lineHeight: 'base',
      sx: {
        fontVariantNumeric: 'lining-nums proportional-nums',
      },
    },
    methodPrice: {
      alignSelf: 'center',
      color: 'brandColors.charcoal',
      flexShrink: 0,
      fontFamily: 'body',
      fontSize: {base: 'sm', md: 'md'},
      fontStyle: 'normal',
      fontWeight: 600,
      letterSpacing: 'normal',
      lineHeight: 'base',
      sx: {
        fontVariantNumeric: 'lining-nums proportional-nums',
      },
    },
    disclaimer: {
      color: 'gray.700',
      fontFamily: 'body',
      fontSize: {base: '1xs', md: 'xs'},
      fontWeight: 'normal',
      letterSpacing: 'labelTight',
      lineHeight: 'tall',
      marginTop: {base: 3, md: 4},
    },
  },
};

export default PdpDeliveryAvailability;
